// extracted by mini-css-extract-plugin
export var active = "_jl-e";
export var blink = "_jl-f";
export var dropDownSelector = "_jl-5";
export var dropDownWrapper = "_jl-4";
export var fakeCursor = "_jl-d";
export var fontSizeButton = "_jl-7";
export var formQuillEditor = "_jl-0";
export var pressed = "_jl-g";
export var qlBlank = "_jl-1";
export var textFormattingToolbar = "_jl-2";
export var textFormattingToolbarClosed = "_jl-3";
export var textFormattingToolbarInline = "_jl-6";
export var textToolbarOption = "_jl-8";
export var toolbarCell = "_jl-a";
export var toolbarCellCollapsed = "_jl-b";
export var toolbarOptionHitArea = "_jl-c";
export var toolbarOverflow = "_jl-9";